const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StudioShotReportQueryURL: any = {
    QueryStudioShotReport: Backofficebff + '/v1/studio-shot-report/query',
};
